import { Alignment } from 'pdfmake/interfaces'

export const FONTS = {
  Roboto: {
    normal:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
}

const CELL_DEFAULT_STYLE = {
  fontSize: 8,
  margin: [5, 5] as [number, number],
}

export const DEFAULT_STYLE = {
  font: 'Roboto',
  fontSize: 8,
  bold: false,
}

export const REPORT_STYLES = {
  header: {
    ...DEFAULT_STYLE,
    fontSize: 12,
    bold: true,
    alignment: 'justify' as Alignment,
    marginBottom: 10,
  },
  information: {
    ...DEFAULT_STYLE,
    bold: true,
    alignment: 'justify' as Alignment,
    margin: [5, 5, 5, 5] as [number, number, number, number],
  },
  table: CELL_DEFAULT_STYLE,
  pageTitle: {
    ...DEFAULT_STYLE,
    margin: [0, 0, 0, 0] as [number, number, number, number],
    fillColor: '#2E86C1',
    alignment: 'center' as Alignment,
  },
  docVersion: {
    ...DEFAULT_STYLE,
    alignment: 'right' as Alignment,
    marginTop: 4,
  },
  sectionTitle: {
    ...DEFAULT_STYLE,
    fontSize: 14,
    marginTop: 20,
    marginBottom: 10,
  },
  label: {
    ...DEFAULT_STYLE,
    bold: true,
    marginBottom: 2,
  },
  field: {
    ...DEFAULT_STYLE,
  },
  cardLabel: {
    ...DEFAULT_STYLE,
    bold: true,
    fontSize: 12,
  },
}

export const PAGE_HEADER_DEFAULT_STYLE = {
  alignment: 'center',
  color: '#FFFFFF',
  fillColor: '#172983',
  bold: true,
  margin: [0, 10],
  fontSize: 10,
}

export const TABLE_HEADER_DEFAULT_STYLE = {
  alignment: 'center',
  color: '#FFFFFF',
  fillColor: '#172983',
  bold: true,
  margin: [0, 10],
  fontSize: 10,
}

export const TABLE_HEADER_DEFAULT_STYLE_D = {
  alignment: 'center',
  color: '#FFFFFF',
  fillColor: '#172983',
  bold: true,
  fontSize: 10,
  layout: 'noBorders',
}

export const SUBHEADER_DEFAULT_STYLE = {
  color: '#000000',
  fillColor: '#E5E5E5',
  bold: true,
  alignment: 'center',
  fontSize: 8,
  margin: [0, 10],
}
